// extracted by mini-css-extract-plugin
module.exports = {"map":"DragTable_map_C8Tap","pin":"DragTable_pin_34nUd","users":"DragTable_users_dC6g2","container":"DragTable_container_9Ui9K","button":"DragTable_button_1zCut"};